export interface AccountErrorProps {
  /* eslint-disable */
  errorType: string;
  onCloseCallback?: (e?: any) => void;
  callLogOut?: boolean;
}

export enum AccountErrorType {
  LOGIN_BLOCKED = 'login_blocked',
  ACCOUNT_INACTIVE_ERROR = 'account_is_inactive',
  ACCOUNT_NOT_IN_BETA = 'beta_privilege_not_found',
  PRODUCT_USER_BLOCKED = 'product_user_blocked',
}
